<slb-navigation-framework applicationName="Coiled Tubing Application Suite"
  [hasSidenav]="false"
  [pageTitle]="pageTitle"
  [displayViewModeButtons]="false"
  [hideBackgroundSelector]="true">
  <slb-framework-toolbar>
    <a id="homeButton" class="dls-navigation-item" title="Home" routerLink="home">
      <mat-icon svgIcon="home"></mat-icon>
    </a>
  </slb-framework-toolbar>

  <slb-framework-content>
    <ng-content *ngTemplateOutlet="content"></ng-content>
  </slb-framework-content>

</slb-navigation-framework>

<ng-template #content>
  <div class="main">
    @if (!!(navigation$ | async)?.hasSidenav) {
      <sidenav></sidenav>
    }
    <div class="content">
      @if (showHeader) {
        <div class="dls-page-header-container">
          <slb-framework-page-header
            [pageTitle]="pageTitle">
          </slb-framework-page-header>
        </div>
      }
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-template>
